export default "__VITE_ASSET__JcP6w7tJ__"